export default __webpack_public_path__ + "static/media/fc3.6ca8489b.jpg";